import { render, staticRenderFns } from "./tab-customClass-editor.vue?vue&type=template&id=2960969c&scoped=true&"
import script from "./tab-customClass-editor.vue?vue&type=script&lang=js&"
export * from "./tab-customClass-editor.vue?vue&type=script&lang=js&"
import style0 from "./tab-customClass-editor.vue?vue&type=style&index=0&id=2960969c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2960969c",
  null
  
)

export default component.exports